// Fix #5: Remove .00 from all prices on the cart page
(function() {
  var isProcessing = false;

  function removeTrailingZeros() {
    if (window.location.pathname !== "/cart") return;
    if (isProcessing) return;
    isProcessing = true;

    var selectors = [
      ".cart__form-item-price",
      ".cart__footer-subtotal span.ff-body",
      ".cart__form-item-compare-price",
      ".sale-price"
    ];

    selectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        el.childNodes.forEach(function(node) {
          if (node.nodeType === 3 && node.textContent.match(/\.\d{2}/)) {
            node.textContent = node.textContent.replace(/\.\d{2}/g, "");
          }
        });
      });
    });

    isProcessing = false;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", removeTrailingZeros);
  } else {
    removeTrailingZeros();
  }

  var observer = new MutationObserver(function() {
    removeTrailingZeros();
  });

  function startObserving() {
    var cartForm = document.querySelector(".cart__form, [data-cart-form]");
    if (cartForm) {
      observer.observe(cartForm, { childList: true, subtree: true });
    }
    var cartFooter = document.querySelector(".cart__footer, .cart__footer-subtotal-wrapper");
    if (cartFooter) {
      observer.observe(cartFooter, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startObserving);
  } else {
    startObserving();
  }
})();